import type { ContentServiceDictionariesQuery } from '@/graphql/generated';

export enum ContentSection {
  CommonInformation = 'CommonInformation',
  Rooms = 'Rooms',
  Equipment = 'Equipment',
  RestaurantsAndEvents = 'RestaurantsAndEvents',
  SportAndEntertainments = 'SportAndEntertainments',
  ForChildren = 'ForChildren',
  Services = 'Services',
  FoodObjects = 'FoodObjects',
  ConferenceRooms = 'ConferenceRooms'
}

export type UploadContentImageResponse = {
  UploadContentImage: {
    fileId: string;
    fileName: string;
    fileSize: number;
  };
};

export type UploadContentImageVariables = {
  accommodationObjectCid: string;
  section: ContentSection;
  sectionObjectName: string | null | undefined;
  attachment: File;
};

export type DeleteContentImageResponse = {
  DeleteContentImage: {
    errors: { message: string }[];
  };
};

export type DeleteContentImageVariables = {
  fileId: string;
  section: ContentSection;
  sectionObjectName: string | null | undefined;
  accommodationObjectCid: string;
};

export type Dictionaries = ContentServiceDictionariesQuery['contentServiceDictionaries'];

export type TreatmentGroup = {
  name: string;
  isChecked: boolean;
  items: {
    name: string;
    options: string[];
    selectedOptions: string[];
  }[];
};
